// 必須質問の設定ファイル
// このファイルを編集することで、質問内容を簡単に変更できます
//
// Stage 1(2026年9月): 固定NPS/7段階評価/トーナメント形式のアンケートを廃止し、
// 初回来店者向け(属性+良かった/気になった点コメント)と
// 2回目以降の来店者向け(リピート理由+要望)の2種類に出し分ける。
// どちらを表示するかは visitorType('first' | 'repeat') で切り替える。
// visitorType はLINEユーザーの過去回答履歴からサーバー側で客観判定される
// (apps/answer-app/supabase/functions/check-eligibility)。

// QuestionsPageと同じデータ構造を使用

export const FIRST_TIME_PAGES = [
  {
    id: 'required-first-page-1',
    review_forms_id: 'required',
    page_number: 1,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: 'required-first-page-2',
    review_forms_id: 'required',
    page_number: 2,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

export const REPEAT_PAGES = [
  {
    id: 'required-repeat-page-1',
    review_forms_id: 'required',
    page_number: 1,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
];

export const FIRST_TIME_QUESTIONS = [
  // ページ1: 属性
  {
    id: 'required_first_1_1',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 8, // プルダウン
    question_number: 1,
    question_text: '性別を教えてください。',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      { id: 'opt_first_1_1_1', review_questions_id: 'required_first_1_1', choice_number: 1, choice_name: '男性' },
      { id: 'opt_first_1_1_2', review_questions_id: 'required_first_1_1', choice_number: 2, choice_name: '女性' },
      { id: 'opt_first_1_1_3', review_questions_id: 'required_first_1_1', choice_number: 3, choice_name: 'その他' }
    ],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_1_2',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 8,
    question_number: 2,
    question_text: '本日はどなたとご一緒に来店されましたか？',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      { id: 'opt_first_1_2_1', review_questions_id: 'required_first_1_2', choice_number: 1, choice_name: 'おひとり' },
      { id: 'opt_first_1_2_2', review_questions_id: 'required_first_1_2', choice_number: 2, choice_name: '初対面の人' },
      { id: 'opt_first_1_2_3', review_questions_id: 'required_first_1_2', choice_number: 3, choice_name: 'パートナー' },
      { id: 'opt_first_1_2_4', review_questions_id: 'required_first_1_2', choice_number: 4, choice_name: '友人' },
      { id: 'opt_first_1_2_5', review_questions_id: 'required_first_1_2', choice_number: 5, choice_name: 'ご家族' },
      { id: 'opt_first_1_2_6', review_questions_id: 'required_first_1_2', choice_number: 6, choice_name: '会社の同僚' },
      { id: 'opt_first_1_2_7', review_questions_id: 'required_first_1_2', choice_number: 7, choice_name: 'ビジネス利用' }
    ],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_1_3',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 8,
    question_number: 3,
    question_text: '年齢を教えてください。',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      { id: 'opt_first_1_3_1', review_questions_id: 'required_first_1_3', choice_number: 1, choice_name: '〜19歳' },
      { id: 'opt_first_1_3_2', review_questions_id: 'required_first_1_3', choice_number: 2, choice_name: '20歳〜24歳' },
      { id: 'opt_first_1_3_3', review_questions_id: 'required_first_1_3', choice_number: 3, choice_name: '25歳〜29歳' },
      { id: 'opt_first_1_3_4', review_questions_id: 'required_first_1_3', choice_number: 4, choice_name: '30歳〜34歳' },
      { id: 'opt_first_1_3_5', review_questions_id: 'required_first_1_3', choice_number: 5, choice_name: '35歳〜39歳' },
      { id: 'opt_first_1_3_6', review_questions_id: 'required_first_1_3', choice_number: 6, choice_name: '40歳〜44歳' },
      { id: 'opt_first_1_3_7', review_questions_id: 'required_first_1_3', choice_number: 7, choice_name: '45歳〜49歳' },
      { id: 'opt_first_1_3_8', review_questions_id: 'required_first_1_3', choice_number: 8, choice_name: '50歳〜54歳' },
      { id: 'opt_first_1_3_9', review_questions_id: 'required_first_1_3', choice_number: 9, choice_name: '55歳〜59歳' },
      { id: 'opt_first_1_3_10', review_questions_id: 'required_first_1_3', choice_number: 10, choice_name: '60歳〜69歳' },
      { id: 'opt_first_1_3_11', review_questions_id: 'required_first_1_3', choice_number: 11, choice_name: '70歳〜79歳' },
      { id: 'opt_first_1_3_12', review_questions_id: 'required_first_1_3', choice_number: 12, choice_name: '80歳〜' }
    ],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_1_4',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 8,
    question_number: 4,
    question_text: 'お住まいの都道府県を教えてください。',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
      '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
      '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県',
      '岐阜県', '静岡県', '愛知県', '三重県',
      '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
      '鳥取県', '島根県', '岡山県', '広島県', '山口県',
      '徳島県', '香川県', '愛媛県', '高知県',
      '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県',
      '沖縄県'
    ].map((name, index) => ({
      id: `opt_first_1_4_${index + 1}`,
      review_questions_id: 'required_first_1_4',
      choice_number: index + 1,
      choice_name: name
    })),
    question_option_linear_scale: []
  },
  {
    id: 'required_first_1_5',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 8,
    question_number: 5,
    question_text: '当店を何でお知りになりましたか？',
    is_required: true,
    // 「その他」を選んだときに記入欄を出す (任意)。内容は preset_answer_attributes.discovery_other_text に保存
    other_text_choice: 5,
    other_text_label: '差し支えなければ、具体的に教えてください（任意）',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    // choice_number は保存される値 (lottery の discoveryChannelMap と対応) のため変えない。
    // 「知人・友人の紹介」(2026-10 追加) は6番だが、表示は display_order で「その他」の前にする
    question_option_choices: [
      { id: 'opt_first_1_5_1', review_questions_id: 'required_first_1_5', choice_number: 1, display_order: 1, choice_name: 'SNS' },
      { id: 'opt_first_1_5_2', review_questions_id: 'required_first_1_5', choice_number: 2, display_order: 2, choice_name: '通りかかった' },
      { id: 'opt_first_1_5_3', review_questions_id: 'required_first_1_5', choice_number: 3, display_order: 3, choice_name: '口コミサイト' },
      { id: 'opt_first_1_5_4', review_questions_id: 'required_first_1_5', choice_number: 4, display_order: 4, choice_name: '検索' },
      { id: 'opt_first_1_5_6', review_questions_id: 'required_first_1_5', choice_number: 6, display_order: 5, choice_name: '知人・友人の紹介' },
      { id: 'opt_first_1_5_5', review_questions_id: 'required_first_1_5', choice_number: 5, display_order: 6, choice_name: 'その他' }
    ],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_1_6',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 1, // 短文
    question_number: 6,
    question_text: 'ご自身がどんな人か、一言で教えてください。(店舗がお客様を覚えるためのメモとして使わせていただきます)',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_1_7',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-1',
    pege_number: 1,
    question_type_id: 8,
    question_number: 7,
    question_text: '通算で何回目のご来店ですか？',
    is_required: true,
    // 自己申告の来店回数。preset_answer_attributes.self_reported_visit_count に保存する。
    // システム内部の「アンケート回答回数」(visit_count)とは別概念で、判定ロジックには使わない (Issue #2)
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      { id: 'opt_first_1_7_1', review_questions_id: 'required_first_1_7', choice_number: 1, choice_name: '1回目(初めて)' },
      { id: 'opt_first_1_7_2', review_questions_id: 'required_first_1_7', choice_number: 2, choice_name: '2〜5回目' },
      { id: 'opt_first_1_7_3', review_questions_id: 'required_first_1_7', choice_number: 3, choice_name: '6〜10回目' },
      { id: 'opt_first_1_7_4', review_questions_id: 'required_first_1_7', choice_number: 4, choice_name: '11回目以上' }
    ],
    question_option_linear_scale: []
  },

  // ページ2: 良かった点・気になった点
  {
    id: 'required_first_2_1',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-2',
    pege_number: 2,
    question_type_id: 3, // 単一選択
    question_number: 1,
    question_text: '料理・接客・衛生の中で、一番良かったのはどれですか？',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      { id: 'opt_first_2_1_1', review_questions_id: 'required_first_2_1', choice_number: 1, choice_name: '料理' },
      { id: 'opt_first_2_1_2', review_questions_id: 'required_first_2_1', choice_number: 2, choice_name: '接客' },
      { id: 'opt_first_2_1_3', review_questions_id: 'required_first_2_1', choice_number: 3, choice_name: '衛生' }
    ],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_2_2',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-2',
    pege_number: 2,
    question_type_id: 2, // 長文
    question_number: 2,
    question_text: 'その良かった点について、詳しく教えてください。',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_2_3',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-2',
    pege_number: 2,
    question_type_id: 3,
    question_number: 3,
    question_text: '料理・接客・衛生の中で、気になった点があるのはどれですか？',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [
      { id: 'opt_first_2_3_1', review_questions_id: 'required_first_2_3', choice_number: 1, choice_name: '料理' },
      { id: 'opt_first_2_3_2', review_questions_id: 'required_first_2_3', choice_number: 2, choice_name: '接客' },
      { id: 'opt_first_2_3_3', review_questions_id: 'required_first_2_3', choice_number: 3, choice_name: '衛生' },
      { id: 'opt_first_2_3_4', review_questions_id: 'required_first_2_3', choice_number: 4, choice_name: '特になし' }
    ],
    question_option_linear_scale: []
  },
  {
    id: 'required_first_2_4',
    review_fome_id: 'required',
    review_form_pages_id: 'required-first-page-2',
    pege_number: 2,
    question_type_id: 2,
    question_number: 4,
    question_text: 'その気になった点について、詳しく教えてください。',
    // 「特になし」が選ばれた場合はこの質問自体を表示・送信しない
    // (RequiredQuestionsPage.js 側で required_first_2_3 の回答を見て出し分ける)
    is_required: false,
    requiredUnless: { questionId: 'required_first_2_3', value: '4' },
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [],
    question_option_linear_scale: []
  }
];

export const REPEAT_QUESTIONS = [
  {
    id: 'required_repeat_1_1',
    review_fome_id: 'required',
    review_form_pages_id: 'required-repeat-page-1',
    pege_number: 1,
    question_type_id: 2,
    question_number: 1,
    question_text: '今回リピートしてくださった理由を教えてください。',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [],
    question_option_linear_scale: []
  },
  {
    id: 'required_repeat_1_2',
    review_fome_id: 'required',
    review_form_pages_id: 'required-repeat-page-1',
    pege_number: 1,
    question_type_id: 2,
    question_number: 2,
    question_text: '当店へのご要望があれば教えてください。',
    is_required: true,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    question_option_choices: [],
    question_option_linear_scale: []
  }
];

// ヘルパー関数(visitorType: 'first' | 'repeat')
export const getRequiredQuestionsForPage = (pageNumber, visitorType) => {
  const questions = visitorType === 'repeat' ? REPEAT_QUESTIONS : FIRST_TIME_QUESTIONS;
  return questions.filter(q => q.pege_number === pageNumber);
};

export const getRequiredPageByNumber = (pageNumber, visitorType) => {
  const pages = visitorType === 'repeat' ? REPEAT_PAGES : FIRST_TIME_PAGES;
  return pages.find(p => p.page_number === pageNumber);
};

export const getTotalRequiredPages = (visitorType) => {
  const pages = visitorType === 'repeat' ? REPEAT_PAGES : FIRST_TIME_PAGES;
  return pages.length;
};
